import merge from 'lodash-es/merge';
import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  production: false,
  isLocal: false,
  auth0Config: {
    domain: 'auth.ppe.cloudmed.com',
    clientId: 'l8IIa2q2wyWubhxHh3fh3VPL9j0fWPx2',
    audience: 'ppe.cloudmed',
    redirectUri: window.location.origin + '/callback',
    useRefreshTokens: true,
    httpInterceptor: {
      allowedList: [
        'https://cmeppepricingcontractapi.azurewebsites.net/api/*',
        'https://cmeppepricingglobalapi.azurewebsites.net/*',
        'https://cmeppepricingphysiciancontractsapi.azurewebsites.net/api/*',
        'https://cmeppepricingworkflowapi.azurewebsites.net/api/*',
        'https://cmeppewkdradminapi.azurewebsites.net/*',
        'https://ps-payer-rules-api.ppe.cloudmed.com/*',
        'https://usermanagementapi.ppe.cloudmed.com/*',
      ],
    },
  },
  api: {
    contractsApi: 'https://cmeppepricingcontractapi.azurewebsites.net/api',
    payerRulesApiBaseURL: 'https://ps-payer-rules-api.ppe.cloudmed.com/api/',
    physicianContractsApi: 'https://cmeppepricingphysiciancontractsapi.azurewebsites.net/api/contract',
    pricingWorkflowApi: 'https://cmeppepricingworkflowapi.azurewebsites.net/api',
    riUserManagementBaseURL: 'https://usermanagementapi.ppe.cloudmed.com/',
  },
  uiUrl: {
    accountInfoURL: 'https://app.ppe.cloudmed.com/account-info?id=',
    adminUrl: 'https://admin.ppe.cloudmed.com/',
    contractsUiUrl: 'https://contracts.ppe.cloudmed.com',
    payerReimbursementConfigUrl:
      'https://payerreimbursementconfigs.ppe.cloudmed.com/payer-reimbursement-configurations/edit?id=',
    pricingUiBaseURL: 'https://pricing.ppe.cloudmed.com',
    contractRepositoryURL: 'https://contractrepository.ppe.cloudmed.com/Physician',
  },
};
export const environment = merge(commonEnv, env);
